// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "compiled-css" + "." + "8ada3b2f07e877ea8915" + ".css";
};